import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #475B69;
`
const st1 = css`
  fill: #DFE2E5;
`
const st2 = css`
  fill: #C9CFD3;
`
const st3 = css`
  fill: #EFECD5;
`
const st4 = css`
  fill: #F9CACD;
`

const st5 = css`
  fill: #263E50;
`

class Entratafi extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path
          css={st0}
          d='M22.2,95.2H12.2v-3.5h10.1V95.2z M87.7,91.7H77.7v3.5h10.1V91.7z'
        />
        <path
          css={st1}
          d='M78.9,48.4l18.8,15.4H1.4l19.7-15.4H78.9z'
        />
        <path css={st2} d='M97.7,65.6v25.3H1.4V65.6H97.7z' />
        <path
          css={st3}
          d='M19.4,82.7h-8.2v-9.4h8.2V82.7z'
        />
        <path
          css={st4}
          d='M34.9,82.7h-8.2v-9.4h8.2V82.7z'
        />
        <path
          css={st5}
          d='M100,63.8c0-0.5-0.2-1-0.6-1.3L81.1,47.1c-0.3-0.3-0.7-0.4-1.1-0.4H67.9L84.8,4.4c0.4-0.9-0.1-1.9-1-2.3
	c-0.9-0.4-1.9,0.1-2.3,1L64.3,46.2c-0.1,0.1-0.1,0.3-0.1,0.4H35.8c0-0.1-0.1-0.3-0.1-0.4L18.4,3c-0.4-0.9-1.4-1.3-2.3-1
	c-0.9,0.4-1.3,1.4-1,2.3l16.9,42.3H20c-0.4,0-0.8,0.1-1.1,0.4L0.6,62.4C0.2,62.8,0,63.3,0,63.8h0v28.3h10v0.2c0,3.2,2.6,5.8,5.8,5.8
	h3.1c3.2,0,5.8-2.6,5.8-5.8v-0.2h50.7v0.2c0,3.2,2.6,5.8,5.8,5.8h3.1c3.2,0,5.8-2.6,5.8-5.8v-0.2h10L100,63.8L100,63.8z M20.6,50.2
	h58.7l16.2,13.6H4.5L20.6,50.2z M21.1,92.3c0,1.2-1,2.2-2.2,2.2h-3.1c-1.2,0-2.2-1-2.2-2.2v-0.2h7.6V92.3z M86.5,92.3
	c0,1.2-1,2.2-2.2,2.2h-3.1c-1.2,0-2.2-1-2.2-2.2v-0.2h7.6V92.3z M96.5,88.6h-93V67.3h93V88.6z M50.1,27.1c-4.7,0-6.8,2.4-7.1,2.6
	c-0.6,0.7-0.5,1.8,0.2,2.4c0.7,0.6,1.8,0.6,2.5-0.1c0.1-0.1,1.3-1.4,4.5-1.4c3.5,0,4.9,1.4,4.9,1.4c0.3,0.4,0.8,0.6,1.3,0.6
	c0.4,0,0.9-0.2,1.2-0.5c0.7-0.7,0.8-1.8,0.1-2.5C57.4,29.4,55.1,27.1,50.1,27.1z M60.3,22.4c0.5,0,0.9-0.2,1.3-0.6
	c0.7-0.7,0.6-1.8-0.1-2.5c-0.2-0.1-3.8-3.5-11.4-3.5c0,0-0.1,0-0.1,0c-7.3,0-10.8,3.4-10.9,3.5c-0.7,0.7-0.7,1.8,0,2.5
	c0.7,0.7,1.8,0.7,2.5,0c0.1-0.1,2.7-2.5,8.5-2.5c6.2,0,9,2.4,9.1,2.5C59.5,22.2,59.9,22.4,60.3,22.4z M38.4,11.8
	c0,0,4.7-3.6,11.9-3.6s11.9,3.6,11.9,3.6c0.3,0.3,0.7,0.4,1.1,0.4c0.5,0,1-0.2,1.4-0.7c0.6-0.8,0.5-1.9-0.3-2.5
	c-0.2-0.2-5.6-4.4-14.1-4.4c-8.5,0-13.9,4.2-14.1,4.4c-0.8,0.6-0.9,1.7-0.3,2.5C36.6,12.2,37.7,12.4,38.4,11.8z M10.4,84.4h8.9
	c1,0,1.8-0.8,1.8-1.8v-9.3c0-1-0.8-1.8-1.8-1.8h-8.9c-1,0-1.8,0.8-1.8,1.8v9.3C8.7,83.6,9.5,84.4,10.4,84.4z M12.2,75h5.4v5.8h-5.4
	V75z M26.4,84.4h8.9c1,0,1.8-0.8,1.8-1.8v-9.3c0-1-0.8-1.8-1.8-1.8h-8.9c-1,0-1.8,0.8-1.8,1.8v9.3C24.6,83.6,25.4,84.4,26.4,84.4z
	 M28.1,75h5.4v5.8h-5.4V75z M46.1,75h42.1c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H46.1c-1,0-1.8,0.8-1.8,1.8S45.2,75,46.1,75z
	 M46.1,81.4h22.1c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H46.1c-1,0-1.8,0.8-1.8,1.8S45.2,81.4,46.1,81.4z'
        />
      </svg>
    )
  }
}

Entratafi.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { Entratafi }
